const TERMINAL_RENEWAL_STATUSES = new Set([
  "APPLIED",
  "FAILED",
  "CANCELLED",
  "EXPIRED",
]);

export function isTerminalRenewalStatus(status: string): boolean {
  return TERMINAL_RENEWAL_STATUSES.has(status);
}

export type PollRenewalStatusOptions<T> = {
  fetchStatus: () => Promise<T>;
  getLifecycleStatus: (status: T) => string;
  intervalMs?: number;
  maxAttempts?: number;
  onUpdate: (status: T) => void;
  onTerminal?: (status: T) => void;
};

export async function pollRenewalStatus<T>(
  options: PollRenewalStatusOptions<T>,
): Promise<T> {
  const intervalMs = options.intervalMs ?? 3000;
  const maxAttempts = options.maxAttempts ?? 40;
  let latest = await options.fetchStatus();
  options.onUpdate(latest);

  if (isTerminalRenewalStatus(options.getLifecycleStatus(latest))) {
    options.onTerminal?.(latest);
    return latest;
  }

  for (let attempt = 1; attempt < maxAttempts; attempt += 1) {
    await new Promise((resolve) => {
      window.setTimeout(resolve, intervalMs);
    });

    latest = await options.fetchStatus();
    options.onUpdate(latest);

    if (isTerminalRenewalStatus(options.getLifecycleStatus(latest))) {
      options.onTerminal?.(latest);
      break;
    }
  }

  return latest;
}
